const fadeDurationMs = 250;
const wrapper = "_7cwbpfacb";
const throbber = "_7ct1d9oyrd";

export { fadeDurationMs, throbber, wrapper };
import "./atom.throbber.style.linaria.module.css";
//# sourceMappingURL=atom.throbber.style.js.map
